import React, { FC } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Menubar } from "primereact/menubar";
import { Button } from "primereact/button";
import { MenuItem, MenuItemOptions } from "primereact/menuitem";
import { routes } from "../app/routes";
import { clearAccessToken } from "../utils/userData";
import { Image } from "primereact/image";

const Template: FC<{ item: MenuItem; options: MenuItemOptions }> = ({
                                                                      item,
                                                                      options
                                                                    }) => {
  return (
    <NavLink
      to={`${item.url}`}
      className={({
                    isActive,
                    isPending
                  }) => isPending ? options.className : isActive ? options.className + " nav-link-active" : options.className}
      onClick={options.onClick}
    >
      <i className={options.iconClassName} />{" "}
      <span className={options.labelClassName}>{item.label}</span>
    </NavLink>
  );
};

export const template = (item: MenuItem, options: MenuItemOptions) => (
  <Template item={item} options={options} />
);

const items = [
  {
    label: "Aktywne zastępstwa",
    icon: "pi pi-fw pi-file",
    url: "/admin/requests",
    template
  }
];

const Nav = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAccessToken();
    navigate(`/${routes.LOGIN}`);
  };

  return (
    <>
      <Menubar
        start={
          <div style={{ marginRight: 10, fontWeight: "bold", display: "flex" }}>
            <Image src="/mwzps.png" width="150" onClick={() => navigate(`/${routes.ADMIN}/${routes.REQUESTS}`)} style={{cursor: "pointer"}} />
          </div>
        }
        model={items}
        end={
          <Button
            label="Wyloguj"
            icon="pi pi-power-off"
            onClick={handleLogout}
          />
        }
      />
    </>
  );
};

export default Nav;